import type { IAuthSignupFields } from '../types/index';
import { useUserApi } from '../features/users/api/useUserApi';

import { useCallback, useEffect, useRef, useState } from 'react';

interface IUseFetchUserReturnValue {
  fetch: () => void;
  hasError: boolean;
  isLoading: boolean;
  user?: IAuthSignupFields;
}

export const useFetchUser = (): IUseFetchUserReturnValue => {
  const userApi = useUserApi();
  const [user, setUser] = useState<IAuthSignupFields | undefined>();
  const ref = useRef(false);
  const [state, setState] = useState({ isLoading: false, hasError: false });

  const fetchUser = useCallback(() => {
    if (!ref.current) {
      ref.current = true;
      setState({ isLoading: true, hasError: false });

      void (async (): Promise<void> => {
        try {
          const res = await userApi.getUser();
          setUser(res);
          setState({ isLoading: false, hasError: false });
        } catch (error) {
          console.error(error);
          setState({ isLoading: false, hasError: true });
        } finally {
          ref.current = false;
        }
      })();
    }
  }, [userApi]);

  useEffect(fetchUser, [fetchUser]);

  return { user, ...state, fetch: () => fetchUser() };
};
